import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCloudConnections(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/cloud-connections', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCloudConnection(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/cloud-connections/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCloudConnection(ctx, cloudConnection) {
      return new Promise((resolve, reject) => {
        axios
          .post('/cloud-connections', cloudConnection)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCloudConnection(ctx, cloudConnection) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/cloud-connections/${cloudConnection.id}`, cloudConnection)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCloudConnection(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/cloud-connections/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchExportCloudConnections() {
      return new Promise((resolve, reject) => {
        axios
          .get('/cloud-connections/export')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
